import React, {useEffect, useState} from "react";
import {Col} from "antd";
import _ from "lodash";
import {SubCompanyFilter} from "../../_defaultComponents/FilterComponents";
import {useStore} from "../../../hooks/useStore";
import {useHistory} from "react-router-dom";

const Filters = ({setCurrentPage, filters, setFilters}) => {
    const history = useHistory();
    const stores = useStore();
    const [subCompanyId, setSubCompanyId] = useState(filters.subCompanyId);

    useEffect(() => {
        setCurrentPage(1);
    }, [subCompanyId]);

    useEffect(() => {
        const newFilters = {subCompanyId};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
            setUrl();
        }
    }, [subCompanyId]);

    const handleUrlSearchParam = () => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const urlSubCompanyId = urlSearchParams.get("subCompanyId");
        if (urlSubCompanyId) {
            setSubCompanyId(urlSubCompanyId);
        }
    };

    const setUrl = () => {
        let path = history?.location?.pathname;
        path += "?";

        if (subCompanyId) {
            path += "subCompanyId=" + subCompanyId;
        }
        history.push(path);
    };

    useEffect(() => {
        handleUrlSearchParam();
    }, []);

    return (
        <React.Fragment>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <SubCompanyFilter
                    value={subCompanyId}
                    onChange={setSubCompanyId}
                    showAllOption={false}
                    allowClear={true}
                    initialCall={stores.meStore.checkRole("isCompanyUser")}
                    disabled={false}
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
